// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"ValidateEmailPage_contentContainer__310Jx","language":"ValidateEmailPage_language__nNi9-"};